class PopupComponent extends HTMLElement {
  constructor(){
    super();
    this.image = this.getAttribute("is_image") === "true" ? true : false
  }
  connectedCallback() {
    this.addEventListener("click", () => this.openPopup());
    document.addEventListener("click", e => this.handleOutsideClick(e));
    this.triggerClick();
    this.createContentDynamically();
    this.mediaChange();
  }

  openPopup() {
    this.popup = document.querySelector(this.getAttribute("data-popup_el"));
    if (!this.popup) return console.warn("Popup element not found!");
    this.popup.classList.toggle("is-visible");
  }

  mediaChange(){
    document.querySelectorAll('.opener__handler').forEach(function(element){
     
     element.addEventListener('click',function(current_ele){

      let this_active = document.querySelector('.opener__handler.activated')
      if(this_active) this_active.classList.remove("activated");
       current_ele.target.classList.add("activated");

       document.querySelectorAll('.media_outer').forEach(function(element2){
         if(element2.classList.contains('active')){
         element2.classList.remove('active');
         }
       })
       var target_show = element.getAttribute('opener-handle');
       document.querySelector(`[target-opener=${target_show}]`).classList.add('active');
       
     })
   })
  }

  handleOutsideClick(e) {
    if (!this.popup) return;
    const popupContent = this.popup.querySelector('.popup__content');
    const clickedInsideContent = popupContent && popupContent.contains(e.target);
    const clickedTrigger = this.contains(e.target);
    const clickedCloseBtn = e.target.closest(".popup__close");

    if ((!clickedInsideContent && !clickedTrigger) || clickedCloseBtn) {
      this.popup.classList.remove("is-visible");
    }
  }
  triggerClick(){
    if(!this.getAttribute("data_click_trigger")) return;
    this.addEventListener("click",()=>{
      document.querySelector(this.getAttribute("data_click_trigger"))?.click();
    })
  }
  createContentDynamically(){
    if(!this.getAttribute("data_media_url")) return;
    if(document.body.querySelector(this.getAttribute("data-popup_el"))) return;
    const media_container = document.createElement("div");
    media_container.classList.add(this.getAttribute("data-popup_el").replace(/[.#]/g,''));
    media_container.style.display = "none";
    if(this.closest(".data_fetched__and_updated_by_js")) {
      this.closest(".data_fetched__and_updated_by_js").appendChild(media_container);
    }
    else{
      document.body.appendChild(media_container)
    }
    const media = this.image ? document.createElement("img") : document.createElement("video");
    media.src = this.getAttribute("data_media_url");
    if(!this.image){
      media.muted = true;
      media.autoplay = true;
      media.loop = true;
      media.playsInline = true;
      media.play();
    }
    if(this.image) media.alt = "see it wet"
    media_container.innerHTML = `<div class="popup_pos_rel popup__content"><span class="popup__close"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><g data-name="02 User"><path d="M25 512a25 25 0 0 1-17.68-42.68l462-462a25 25 0 0 1 35.36 35.36l-462 462A24.93 24.93 0 0 1 25 512z" fill="#333333" opacity="1" data-original="#000000" class=""></path><path d="M487 512a24.93 24.93 0 0 1-17.68-7.32l-462-462A25 25 0 0 1 42.68 7.32l462 462A25 25 0 0 1 487 512z" fill="#333333" opacity="1" data-original="#000000" class=""></path></g></g></svg></span></div>`
    media_container.querySelector(".popup_pos_rel").appendChild(media);
  }
}

if(!customElements.get("popup-component")) customElements.define("popup-component", PopupComponent);